/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import StringResources from 'nls/StringResources';
import {
	FlexLayout,
	FlexItem,
	Label,
	TextInput
} from '@ba/ba-ui-carbon-toolkit';

export default class ColorRgb extends PureComponent {

	static propTypes = {
		color: PropTypes.string,
		onChange: PropTypes.func
	}
	static defaultProps = {
		color: '#FFFFFF'
	};

	_validator = (regex, color) =>{
		let matches = color.match(regex);
		return matches && matches.length == 1 && matches[0] === color;
	}

	validateHexInput = (value) =>{
		// inject the hex string identifier if not present
		if ( value.length == 0 || value[0] != '#' ) {
			value = '#' + value;
		}

		// if any pair is not hex digits, return before updating state to prevent the input
		const regex = /[0-9A-Fa-f]{1,2}/;
		if ( value.length > 1 && !this._validator(regex, value.substr(1,2))) {
			return;
		}
		if ( value.length > 3 && !this._validator(regex, value.substr(3,2))) {
			return;
		}
		if ( value.length > 5 && !this._validator(regex, value.substr(5,2))) {
			return;
		}

		// only "process" the input if it's a full hex string
		if ( value.length == 7 ) {
			this.props.onChange(value.toUpperCase(), false);
		}
	}

	render() {
		return (
			<div>
				<Label
					id='idHexCodeLabel'
					type='caption'
					label={StringResources.get('hexCode')}
					htmlFor='idTextRgbCode'
					title={StringResources.get('hexCode')}
					alt={StringResources.get('hexCode')}
				/>
				<FlexLayout>
					<FlexItem style={{ width: '160px' }}>
						<TextInput
							id='idTextRgbCode'
							light
							value={this.props.color}
							onValueChange={(value) => this.validateHexInput(value)}
							fullWidth
							maxLength='7'
							tabIndex={0}
						/>
					</FlexItem>
					<FlexItem>
						<div
							id='divPreview'
							className='clsPreviewBox'
							style={{ backgroundColor: this.props.color }}
						/>
					</FlexItem>
				</FlexLayout>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/ColorRgb.js